import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ResourceBundleService } from '../services/resource-bundle.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { constants } from '../../../constants/constants';

@Component({
    selector: 'app-email-form',
    templateUrl: './email-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmailFormComponent implements OnChanges {
	@Input() public loggedInEmail: any;
	@Input() public errors: any;

	public emailForm: UntypedFormGroup;

	constructor(public resourceBundle: ResourceBundleService, private readonly fb: UntypedFormBuilder) {
		this.buildForm();
	}

	isValid(): boolean {
		for (const control in this.emailForm.controls) {
			if (!this.emailForm.controls[control].valid) {
				return false;
			}
		}
		return true;
	}

	buildForm(): void {
		this.emailForm = this.fb.group({
			email: [
				this.loggedInEmail,
				[Validators.required, Validators.minLength(6), Validators.maxLength(60), Validators.pattern(constants.VALIDATION_REGEX.EMAIL)]
			]
		});
	}

	updateForm() {
		if (this.emailForm) {
			this.emailForm.setValue({
				email: this.loggedInEmail
			});
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['loggedInEmail']) {
			this.updateForm();
		}
	}

	get formGroup() {
		return this.emailForm;
	}

	getData(): any {
		return this.emailForm.controls['email'].valid ? this.emailForm.controls['email'].value : this.loggedInEmail;
	}
}
